import { render } from "./DetailsBlock.vue?vue&type=template&id=70bcf695&scoped=true&ts=true"
import script from "./DetailsBlock.vue?vue&type=script&lang=ts"
export * from "./DetailsBlock.vue?vue&type=script&lang=ts"

import "./DetailsBlock.vue?vue&type=style&index=0&id=70bcf695&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bcf695"]])

export default __exports__